import React from 'react';
import PropTypes from 'prop-types';

const TotalTime = ({
  totalTime,
  separator
}) => /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("span", {
  "data-test": "total-time"
}, totalTime), separator && /*#__PURE__*/React.createElement("span", {
  className: "slds-m-horizontal_x-small"
}, "\u2022"));
TotalTime.displayName = "TotalTime";
TotalTime.propTypes = {
  totalTime: PropTypes.string.isRequired,
  separator: PropTypes.bool
};
TotalTime.defaultProps = {
  separator: true
};
var TotalTime$1 = TotalTime;

export { TotalTime$1 as default };
